module.exports = __webpack_public_path__ + "media/images/flags/32/Northern-Cyprus-b10dc37528582286c4070e0eaf656212.png";